<div (click)="checkRadio($event)" class="radio-button-container" [class.checked]="checked">
    <div class="card-header">
        <mat-radio-button
            #radioButton
            [value]="value"
        ></mat-radio-button>
        <div class="title">{{ label }}</div>
        <mat-icon class="icon">{{ icon }}</mat-icon>
    </div>
    <ng-content></ng-content>
</div>